//frontend/src/pages/history/historystages/AncientCivilisations.jsx
import React from 'react';
import JourneyPage from '../../../components/SubjectsPage';
import historyImage from '../../../assets/history2/Historical_Topics_-_Middle_Ages.png';

const subTopics = [
  { name: 'Byzantine Empire', route: '/History-Byzantine-Empire', key: 'Byzantine Empire' },
  { name: 'Islamic Caliphates', route: '/History-Islamic-Caliphates', key: 'Islamic Caliphates' },
  { name: 'Medieval Europe', route: '/History-Medieval-Europe', key: 'Medieval Europe' },
  { name: 'Mongol Empire', route: '/History-Mongol-Empire', key: 'Mongol Empire' },
  { name: 'Crusades', route: '/History-Crusades', key: 'Crusades' },
  { name: 'Feudal Japan', route: '/History-Feudal-Japan', key: 'Feudal Japan' },
  { name: 'African Kingdoms (e.g., Mali, Ghana)', route: '/History-African-Kingdoms', key: 'African Kingdoms (e.g., Mali, Ghana)' }
];

function HistoryPageMA() {
  return (
    <JourneyPage
      title="The Middle Ages"
      backgroundImage={historyImage}
      subTopics={subTopics}
      backRoute="/history2"
      chapterFooter=""
    />
  );
}

export default HistoryPageMA;
